module.exports = __webpack_public_path__ + "static/media/wayd.34d369a5.jpeg";